import clsx from 'clsx'

export function Heading({ className, level = 1, ...props }) {
  const Element = `h${level}`
  return <Element {...props} className={clsx('text-2xl font-semibold tracking-normal text-zinc-950 sm:text-xl', className)} />
}

export function Subheading({ className, level = 2, ...props }) {
  const Element = `h${level}`
  return <Element {...props} className={clsx('text-sm font-semibold tracking-normal text-zinc-950', className)} />
}
